// 読み込み中の共通パーツ（三浦さん指摘 2026-08-29「読み込みしてる手ごたえほしい」）。
//
// 取得が終わる前に「0件」「0 / 0 名」と描いてしまうと、データが無いように見えてしまう。
// 数字を出す代わりに、ここのスケルトンとスピナーで「取りに行っている」ことを見せる。
// キーフレーム（hsd-skeleton / hsd-spin）は src/styles/app.css にある。

import React from "react";

export function Spinner({ size = 12 }: { size?: number }) {
  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        height: size,
        border: "2px solid var(--border-strong, #c9d2df)",
        borderTopColor: "transparent",
        borderRadius: "50%",
        animation: "hsd-spin .8s linear infinite",
      }}
    />
  );
}

/** 読み込み中であることを示すラベル（スピナー＋文言） */
export function LoadingLabel({ text = "読み込み中…" }: { text?: string }) {
  return (
    <span className="tiny muted row gap-6" style={{ alignItems: "center" }}>
      <Spinner /> {text}
    </span>
  );
}

export function SkeletonBar({ w, h = 12 }: { w: number | string; h?: number }) {
  return (
    <div
      style={{
        width: typeof w === "number" ? `${w}px` : w,
        height: h,
        borderRadius: 4,
        background: "linear-gradient(90deg, var(--surface-2) 25%, var(--border) 50%, var(--surface-2) 75%)",
        backgroundSize: "200% 100%",
        animation: "hsd-skeleton 1.2s ease-in-out infinite",
      }}
    />
  );
}

/** カード風のプレースホルダを n 行（一覧の読み込み中に使う） */
export function SkeletonRows({ rows = 3 }: { rows?: number }) {
  return (
    <div className="col gap-12" aria-hidden>
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={i}
          style={{
            border: "1px solid var(--border)",
            borderRadius: 8,
            padding: "12px 14px",
            opacity: 1 - i * 0.22,
          }}
        >
          <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
            <SkeletonBar w={52} h={16} />
            <SkeletonBar w={96} h={14} />
            <SkeletonBar w={140} h={11} />
          </div>
          <SkeletonBar w="70%" h={11} />
          <div style={{ height: 6 }} />
          <SkeletonBar w="55%" h={11} />
        </div>
      ))}
    </div>
  );
}

/** テーブルの読み込み中プレースホルダ（列数ぶんの帯を n 行） */
export function SkeletonTableRows({ cols, rows = 5 }: { cols: number; rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, r) => (
        <tr key={r} style={{ opacity: 1 - r * 0.15 }}>
          {Array.from({ length: cols }, (_, c) => (
            <td key={c}>
              <SkeletonBar w={c === 1 ? "70%" : "45%"} h={11} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
